import { useAuth0 } from '@auth0/auth0-react'
import React, { Fragment } from 'react'
import { NavLink } from 'react-router-dom'

const MainNav = () => {
  const { isAuthenticated } = useAuth0()

  return (
    <>
      <NavLink
        to="/"
        exact
        className="nav-link"
        activeClassName="router-link-exact-active"
      >
        Home
      </NavLink>
      {isAuthenticated && (
        <Fragment>
          <NavLink
            to="/callback"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            Auth0 CB
          </NavLink>
          <NavLink
            to="/verify-email"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            Verify Email
          </NavLink>
          <NavLink
            to="/user-email-verification"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            User Email Verification
          </NavLink>
          <NavLink
            to="/setup-caregiver-profile"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            Setup Caregiver Profile
          </NavLink>
          <NavLink
            to="/setup-patient-profile"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            Setup Patient Profile
          </NavLink>
          <NavLink
            to="activate-treatment"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            Activate Treatment
          </NavLink>
          <NavLink
            to="download-endeavorrx"
            exact
            className="nav-link"
            activeClassName="router-link-exact-active"
          >
            Download EndeavorRx
          </NavLink>
        </Fragment>
      )}
    </>
  )
}

export default MainNav
